module.exports = __webpack_public_path__ + "img/mer_introduction.febecd98.png";